import PaymentProviderTokenDeleteModal from './payment-provider-token-delete-modal-view'

export default PaymentProviderTokenDeleteModal
